import Vue from 'vue'
import Vuex from 'vuex'
import VueAnalytics from "vue-analytics"
import VueGtag from 'vue-gtag'
import 'es6-promise/auto'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import './assets/styles.scss'
//import 'bootstrap/dist/css/bootstrap.min.css'

Vue.config.productionTip = false;

Vue.use(Vuex);

/*
Vue.use(VueAnalytics, {
  id: 'UA-163317996-1',
  commands: {
    trackOutbound (resource = 'unknown'){
      this.$ga.query('send', 'event', 'outbound', 'click', resource)
    }
  },
  router
});
 */
Vue.use(VueGtag, {
  config: {
    id: "G-F809EYDY2D"
  }
}, router)

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

Vue.component('multiselect', Multiselect);

Vue.filter('timeFormat', function(value){
  if(!value) return '';
  return moment(value, 'HH:mm:ss').format('h:mm A');
});

Vue.filter('phoneNum', function(value){
  if(!value) return '';
  return "(" + value.substring(0,3) + ") " + value.substring(3,6) + "-" + value.substring(6)
});

const store = new Vuex.Store({
  state: {
    pageNumber: 0,
    pageSize: 20,
    textSearch: "",
    selectedSubpops: [],
    selectedCategories: [],
    selectedPayers: [],
    selectedAges: [],
    geoPlace: {},
    geoRadius: 10,
    crisisAsked: false,
    shareActive: false,
    shareResources: []
  },
  getters: {
      geoSearchText (state){
        if(state.geoPlace.formatted_address){
          return state.geoPlace.formatted_address;
        } else {
          return "";
        }
      }
  },
  mutations: {
    nextPage (state) {
      state.pageNumber++
    },
    prevPage (state) {
      state.pageNumber--
    },
    resetPage (state) {
      state.pageNumber = 0
    },
    setTextSearch (state, newText){
      state.textSearch = newText
    },
    setSelectedSubpops (state, newSubpops){
      state.selectedSubpops = newSubpops
    },
    setSelectedAges (state, newAges){
      state.selectedAges = newAges
    },
    setSelectedCategories (state, newCategories){
      state.selectedCategories = newCategories
    },
    setSelectedPayers (state, newPayers){
      state.selectedPayers = newPayers
    },
    setGeoPlace (state, newGeoPlace){
      state.geoPlace = newGeoPlace
    },
    setGeoRadius (state, newGeoRadius){
      state.geoRadius = newGeoRadius
    },
    setCrisisAsked (state, newCrisisAsked){
      state.crisisAsked = newCrisisAsked
    },
    setShareActive (state, newShareActive){
      state.shareActive = newShareActive
    },
    setShareResources (state, newShareResources){
      state.shareResources = newShareResources
    }
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');

